import axios from 'axios';
import { onError, onSuccess } from './interceptors';

const api = axios.create({
    baseURL: '/api',
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    },
    withCredentials: true,
    withXSRFToken: true,
}); 

api.interceptors.response.use(
    onSuccess,
    onError
);

export default api;